// Marketing-site visitor analytics (Umami). No-op when the tracker is not loaded
// (dev/preview builds, or when the user blocks third-party scripts).

type EventProps = Record<string, string | number | boolean>;

declare global {
  interface Window {
    umami?: {
      track: (name: string, data?: EventProps) => void;
    };
  }
}

export function trackEvent(name: string, data?: EventProps): void {
  if (typeof window === "undefined") return;
  window.umami?.track(name, data);
}
